import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import moment from 'moment';

import { Configuration } from '../../classess/configuration/configuration';

import { GlobalFormats } from '../../classess/main/globalFormats';

import ConfigurationAddEditDetails from './ConfigurationAddEditDetails';
import {
    awaitDelayAsync, badgetStatusGeneric, getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, handleResponseMessageAsync, settings, styles, LoadingSection
} from '../../helpers/main';
import { ConfigurationService } from '../../services/configurations/ConfigurationService';

import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';

const $ = window.jqGlobal || window.jQuery;

const { icons, images, labels, messages, } = settings;

const currentMethod = 'Configurations';

export default function Configurations({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const dtConfigurationsId = 'dtConfigurations';
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: true,
        add: false,
    });
    const isMount = useRef(true);

    const [configuration, setConfiguration] = useState(Configuration.getClass({}, false));
    const [configurations, setConfigurations] = useState([Configuration.getClass({}, false)]);
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        languageObj: languageObj,
        dtConfigurationsId: dtConfigurationsId,
        dtConfigurationsRowId: 0,
    });
    const controls = {
        buttons: {
            addEditDetails: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddEditDetails',
            },
        },
        dataTables: {
            configurations: {
                inputs: {
                    search: {
                        id: `${dtConfigurationsId}_filter input`,
                        defaultClass: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtConfigurationsId}_length select`,
                        defaultClass: '',
                    },
                },
            },
        },
        icons: {
            addEditDetails: {
                id: 'iconAddEditDetails',
                defaultClass: icons?.fasFa?.plusCircle,
            },
        },
        spiners: {
            addEditDetails: {
                id: 'spAddEditDetails',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    //#region configuration
    const getAddConfiguration = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getAddConfiguration';
        try {
            e?.preventDefault?.();

            //#region validate data
            if (configurations.length > 0 && configurations[0]?.id > 0) {
                response = getResponse({ type: 1, msgText: messages?.thisModuleDoesNotAllowMoreThanOneRecord[languageObj?.id] });
                return;
            }
            //#endregion validate data

            setProcess(prev => ({ ...prev, add: true, showLoading: true, }));

            //#region set new data
            setConfiguration({
                ...Configuration.getClass({}, false),
                fromDateTime: moment(new Date())?.format(`${languageObj?.format?.date?.f13} ${languageObj?.format?.time?.f2}`),
                toDateTime: moment(new Date())?.format(`${languageObj?.format?.date?.f13} ${languageObj?.format?.time?.f2}`),
            });
            await awaitDelayAsync({ delayTime: settings?.timers?.twoNanoSeconds });
            setModalObj(prev => ({
                ...prev,
                type: 0,
                auth: auth,
                showModal: true,
            }));
            //#endregion set new data
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, add: false, showLoading: false, }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const getEditConfiguration = async ({
        e = {},
        id = '',
        description = '',
        rowId = '',
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getEditConfiguration';
        try {
            //#region variables
            let configurationData = Configuration.getClass({}, false);
            //#endregion variables

            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, showLoading: true, }));

            //#region configuration (get byid)
            response = await ConfigurationService.getById({
                auth,
                id: id,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            configurationData = response?.result || {};
            //#endregion configuration (get byid)

            //#region check data
            if (isUndNullEmp({ data: configurationData?.id, subMethod: currentMethod })?.result || configurationData?.id <= 0) {
                response = getResponse({ type: 1, msgText: `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/>${labels?.name?.[languageObj?.id]}: <b>${description}</b><br/>` });
                return;
            }
            //#endregion check data

            setConfiguration(configurationData);

            setModalObj(prev => ({
                ...prev,
                type: 1,
                showModal: true,
                dtConfigurationsRowId: rowId,
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const deleteConfiguration = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'deleteConfiguration';
        try {
            e?.preventDefault?.();

            //#region show message
            const msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.configuration[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };
            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                confirmButtonColor: settings.colors.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: settings.colors.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                customClass: {
                    confirmButton: settings?.html?.buttons?.primary,
                    cancelButton: settings?.html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete data (configuration)
                        preConfirmResponse = await ConfigurationService.deleteAsync({
                            auth,
                            id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (configuration)

                        //#region delete datatable (configuration)
                        $(`#${dtConfigurationsId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);
                        //#endregion delete datatable (configuration)

                        setConfigurations([]);

                        preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire(swalProperties);

            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion configuration

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                setProcess(prev => ({ ...prev, showLoading: true, }));

                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (configuration)
                response = await ConfigurationService.getAll({
                    auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                const configurationsData = response?.result || [];
                setConfigurations(configurationsData);
                //#endregion get data (configuration)

                //#region set datatable
                if (!isUndNullEmp({ data: configurationsData, subMethod: currentMethod })?.result &&
                    configurationsData.length > 0) {
                    response = setDataInDataTable({ data: configurationsData, subMethod: currentMethod, });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataTables';
        try {
            $(`#${dtConfigurationsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.name?.[languageObj?.id], width: '75%', },
                    { title: labels?.isActive?.[languageObj?.id], width: '10%', },
                    { title: labels?.pagined[languageObj?.id], width: '10%', className: 'text-right', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtConfigurationsId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setQueryCode';
        try {
            //#region process
            $(`#${dtConfigurationsId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtConfigurationsId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getEditConfiguration({ e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case 'details':
                            break;
                        case 'delete':
                            deleteConfiguration({ e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            //#region process
            const configurationDt = data.map((configuration) => {
                const modelConfiguration = Configuration.getClass(configuration, false);
                const processButtons = [];
                return [
                    modelConfiguration.name,
                    badgetStatusGeneric({
                        type: modelConfiguration.isValid ? 0 : 5,
                        value: modelConfiguration.isValid ? labels?.yes?.[languageObj?.id] : labels?.no?.[languageObj?.id]
                    }),
                    modelConfiguration.paginated,
                    getProcessButtons({
                        id: modelConfiguration.id,
                        description: modelConfiguration.name,
                        showDetails: false,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: false,
                        showDelete: true,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: true,
                        processButtons: processButtons,
                    })?.result,
                ];
            });

            $(`#${dtConfigurationsId}`)?.DataTable()?.rows?.add(configurationDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad', });
        return () => {
            isMount.current = false;
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={settings?.app?.views?.settings?.settings} process={settings?.app?.views?.configurations?.configurations} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.configurations?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.configurations?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={settings?.html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.configurations?.[languageObj?.id]} style={{ ...styles?.cardHeaderLogo }} src={images?.icons?.settings}></img>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.configurations?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>
                                                                <i className={`${icons?.fasFa?.cogs} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='ml-auto'>
                                                        <button id={controls?.buttons?.addEditDetails?.id}
                                                            className={controls?.buttons?.addEditDetails?.defaultClass}
                                                            disabled={process?.add}
                                                            style={{ borderRadius: '5px' }}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            onClick={(e) => getAddConfiguration({ e: e, subMethod: controls?.buttons?.addEditDetails?.id })}>
                                                            {process?.add ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.addEditDetails?.id} className={`${controls?.icons?.addEditDetails?.defaultClass}`} />
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className={settings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                            <table id={dtConfigurationsId} className={settings?.html?.dataTables?.formats?.tableHoverW100Border0} style={{ borderRadius: '5px' }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className='text-center py-5'>
                                <i className={`${icons?.fasFa?.lock} fa-3x text-muted mb-3`}></i>
                                <h3 className='text-muted'>{messages?.accessDenied?.[languageObj?.id]}</h3>
                            </div>
                        )}

                    </div>
                </section>
            </div>

            {modalObj?.showModal && (
                <ConfigurationAddEditDetails
                    modalObj={modalObj}
                    setModalObj={setModalObj}
                    configuration={configuration}
                    setConfiguration={setConfiguration}
                    setConfigurations={setConfigurations} />
            )}
        </div>
    )
}